import { lazy } from "react";
import { Navigate } from "react-router-dom";

// Patient portal isn't live yet, but its routes were being eager-imported
// here and dragging react-pdf/pdfjs (~34 KiB) plus other patient-portal-only
// weight into the public quote-funnel bundle. Lazy-load every page so the
// quote-funnel landing only pays for code an anonymous visitor actually
// runs. PatientAuthQuery is the layout wrapper and stays eager — it's tiny
// and runs on every /patient-portal/* hit.
import { PatientAuthQuery } from "components/patient-portal/authentication/PatientAuthQuery";

const PatientSignUp = lazy(
  () => import("../components/patient-portal/authentication/PatientSignUp"),
);
const PatientSignIn = lazy(
  () => import("../components/patient-portal/authentication/PatientSignIn"),
);
const PatientSignOut = lazy(
  () => import("../components/patient-portal/authentication/PatientSignOut"),
);
const PatientMyAccountDashboard = lazy(
  () => import("../pages/patient-portal/patient_my_account_dashboard"),
);
const PatientConfirmEmail = lazy(
  () =>
    import("../components/patient-portal/authentication/PatientConfirmEmail"),
);
const PatientEncountersDashboard = lazy(
  () => import("../pages/patient-portal/patient_dashboard"),
);
const PatientMyPaymentsDashboard = lazy(
  () => import("../pages/patient-portal/patient_my_payments_dashboard"),
);
const PatientInvoiceViewPage = lazy(
  () => import("../pages/patient-portal/patient_invoice_view"),
);
const PatientPayInvoicePage = lazy(
  () => import("../pages/patient-portal/patient_pay_invoice"),
);
const PatientMedicalQuestionnaireDashboard = lazy(
  () =>
    import("../pages/patient-portal/patient_medical_questionnaire_dashboard"),
);
const PatientContractSignerDashboard = lazy(
  () => import("../pages/patient-portal/patient_contract_signer_dashboard"),
);
const PatientQuoteDetailsDashboard = lazy(
  () => import("../pages/patient-portal/patient_quote_details_dashboard"),
);
const PatientFillFormDashboard = lazy(
  () => import("pages/patient-portal/patient_fill_form_dashboard"),
);

export const patientPortalRoutes = [
  {
    path: "/patient-portal",
    element: <PatientAuthQuery />, // Set the layout component
    children: [
      {
        index: true,
        element: <Navigate to="/patient-portal/sign-in" replace />,
      },
      { path: "sign-up", element: <PatientSignUp /> },
      { path: "sign-in", element: <PatientSignIn /> },
      { path: "sign-out", element: <PatientSignOut /> },
      { path: "my-encounters", element: <PatientEncountersDashboard /> },
      { path: "my-account", element: <PatientMyAccountDashboard /> },
      { path: "confirm-email", element: <PatientConfirmEmail /> },
      { path: "quote/:quote_id", element: <PatientQuoteDetailsDashboard /> },
      {
        path: "medical_questionnaire/:side_quote",
        element: <PatientMedicalQuestionnaireDashboard />,
      },
      {
        path: "my-payments/:side_quote?",
        element: <PatientMyPaymentsDashboard />,
      },
      {
        path: "invoice/:invoiceId",
        element: <PatientInvoiceViewPage />,
      },
      {
        path: "invoice/:invoiceId/pay",
        element: <PatientPayInvoicePage />,
      },
      {
        path: "sign-contract/:side_quote/:contract_id",
        element: <PatientContractSignerDashboard />,
      },
      {
        path: "fill-form/:side_quote/:form_id",
        element: <PatientFillFormDashboard />,
      },
    ],
  },
];
